import React, { useState } from "react";
import { HelpCircle, ChevronDown, ChevronRight } from "lucide-react";

// Inline, collapsible "How to answer" guidance for assessment questions.
// Replaces the easy-to-miss bare help icon + modal: the labeled bar sits directly
// above the answer options so respondents can't overlook that guidance exists,
// while staying collapsed by default to keep long assessments compact.
// Flow-agnostic — each assessment flow passes its own per-question help field.
// Renders nothing when there is no help text. Key it by question id at the call
// site so the open state resets when the stepper moves to another question.
const QuestionGuidanceBox = ({ helpText, label = "How to answer this question", defaultOpen = false }) => {
    const [open, setOpen] = useState(defaultOpen);
    if (!helpText || !String(helpText).trim()) return null;

    return (
        <div className="mb-4 border border-blue-200 bg-blue-50 rounded-lg">
            <button
                type="button"
                onClick={() => setOpen(prev => !prev)}
                className="w-full flex items-center gap-2 px-3 py-2 text-sm font-medium text-blue-800 hover:bg-blue-100 rounded-lg"
                aria-expanded={open}
            >
                <HelpCircle className="h-4 w-4 flex-shrink-0" />
                <span className="flex-1 text-left">{label}</span>
                {open
                    ? <ChevronDown className="h-4 w-4 flex-shrink-0" />
                    : <ChevronRight className="h-4 w-4 flex-shrink-0" />}
            </button>
            {open && (
                <div className="px-3 pb-3 pt-1 text-sm text-blue-900 whitespace-pre-wrap">
                    {helpText}
                </div>
            )}
        </div>
    );
};

export default QuestionGuidanceBox;
